/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Consent_DescriptionInputs */

const en_cookies_consent_description = /** @type {(inputs: Cookies_Consent_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some cookies keep the app working. Others tell us what to improve. Pick what you're okay with. You can change your mind any time.`)
};

const pl_cookies_consent_description = /** @type {(inputs: Cookies_Consent_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Część plików cookie jest potrzebna, żeby aplikacja działała. Inne mówią nam, co poprawić. Wybierz, na co się zgadzasz. Możesz to zmienić w każdej chwili.`)
};

/**
* | output |
* | --- |
* | "Some cookies keep the app working. Others tell us what to improve. Pick what you're okay with. You can change your mind any time." |
*
* @param {Cookies_Consent_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_consent_description = /** @type {((inputs?: Cookies_Consent_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Consent_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_consent_description(inputs)
	return en_cookies_consent_description(inputs)
});